export const getAuthHeaders = () => ({
  'JWTAuthorization': localStorage.getItem('token') || ''
});
